import AppRoute from "models/AppRoute"

const GlobalAssetOverviewRoute = new AppRoute({
    route: "/global-asset-overview",
    navbar: true,
    authRequired: true,
})

export default GlobalAssetOverviewRoute
